import { RouteChangeTransitionType } from './../types/global';
import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';
import LayoutBase from '@/components/Common/LayoutBase.vue';
import { isAn } from '@/utils';

const DEFAULT_TITLE = '创作者中心';

Vue.use(Router);

export const constantRoutes = [
  {
    path: '/bridge-demo',
    name: 'BridgeDemo',
    component: () => import('@/views/bridge-demo/index.vue'),
  },
  {
    path: '/',
    component: LayoutBase,
    redirect: {
      name: 'PageLanding',
    },
    children: [
      {
        name: 'PageLanding',
        path: '/page-landing',
        component: () => import('@/views/page-landing/index.vue'),
      },
      {
        name: 'InviteCodeInput',
        path: '/invite-code-input',
        component: () => import('@/views/invite-code-input/index.vue'),
      },
      {
        name: 'CreatorCenterIntroduction',
        path: '/creator-center-introduction',
        component: () => import('@/views/creator-center-introduction/index.vue'),
      },
      {
        name: 'ChannelPermission',
        path: '/channel-permission',
        component: () => import('@/views/channel-permission/index.vue'),
      },
      {
        name: 'ChannelRegister',
        path: '/channel-register',
        component: () => import('@/views/channel-register/index.vue'),
      },
      {
        name: 'ChannelIdPanel',
        path: '/channel-id-panel',
        component: () => import('@/views/channel-id-panel/index.vue'),
        meta: { title: '选择视频号' },
      },
      {
        name: 'RegisterPersonalInfo',
        path: '/register-personal-info',
        component: () => import('@/views/register-personal-info/index.vue'),
        meta: { title: '个人信息' },
      },
      {
        name: 'CreatorNav',
        path: '/creator-nav',
        meta: { pgid: 'CreatorCenter' },
        component: () => import('@/views/creator-nav/index.vue'),
      },
      {
        name: 'RegisterResultFeedback',
        path: '/register-result-feedback',
        component: () => import('@/views/register-result-feedback/index.vue'),
        meta: { title: '申请结果反馈' },
      },
      {
        name: 'ActivityList',
        path: '/activity-list',
        component: () => import('@/views/activity-list/index.vue'),
        meta: { title: '有奖活动', pgid: 'PrizeActivity' },
      },
      {
        name: 'BubbleActivityList',
        path: '/bubble-activity-list',
        component: () => import('@/views/activity-list/bubble-bind.vue'),
        meta: { title: '【做同款气泡】绑定', pgid: 'VideoBind' },
      },
      {
        name: 'ActivityInfo',
        path: '/activity-info/:id/:tabId/:templateID?',
        component: () => import('@/views/activity-info/index.vue'),
        props: true,
        meta: { title: '活动详情', pgid: 'ActivityDetail' },
      },
      {
        name: 'SubmitAuditMaterails',
        path: '/submit-audit-materails/:taskId/:tabId/:templateID?',
        component: () => import('@/views/submit-audit-materails/index.vue'),
        props: true,
        meta: { title: '上传作品发布信息' },
      },
      {
        name: 'BubbleActivityInfo',
        path: '/bubble-activity-info/:id',
        component: () => import('@/views/activity-info/bubble-bind.vue'),
        props: true,
        meta: { title: '活动详情' },
      },
      {
        name: 'BillList',
        path: '/bill-list',
        component: () => import('@/views/bill-list/index.vue'),
        meta: { title: '创作收入' },
      },
      {
        name: 'BillInfo',
        path: '/bill-info/:id',
        props: true,
        component: () => import('@/views/bill-info/index.vue'),
        meta: { title: '收入明细' },
      },
      {
        name: 'PersonalInfo',
        path: '/personal-info',
        props: true,
        component: () => import('@/views/personal-info/index.vue'),
        meta: { title: '个人信息' },
      },
      {
        name: 'AccountManage',
        path: '/account-manage',
        props: true,
        component: () => import('@/views/account-manage/index.vue'),
        meta: { title: '账号管理', pgid: 'ManageAccount' },
      },
      {
        name: 'DeleteAccount',
        path: '/delete-account',
        props: true,
        component: () => import('@/views/delete-account/index.vue'),
        meta: { title: '注销账号' },
      },
      {
        name: 'DeleteAccountNotify',
        path: '/delete-account-notify',
        props: true,
        component: () => import('@/views/delete-account-notify/index.vue'),
        meta: { title: '注销账号' },
      },
      {
        name: 'DeleteAccountPrevent',
        path: '/delete-account-prevent',
        props: true,
        component: () => import('@/views/delete-account-prevent/index.vue'),
        meta: { title: '注销账号' },
      },
      {
        name: 'AppliedDeleteAccount',
        path: '/delete-account-applied',
        props: true,
        component: () => import('@/views/delete-account-applied/index.vue'),
      },
      {
        name: 'CreatorCourse',
        path: '/creator-course',
        props: true,
        component: () => import('@/views/creator-course/index.vue'),
        meta: { title: '创作课堂', pgid: 'CreateCourse' },
      },
      {
        name: 'CreatorInbox',
        path: '/creator-inbox',
        props: true,
        component: () => import('@/views/creator-inbox/index.vue'),
        meta: { title: '通知', pgid: 'Notification' },
      },
      {
        name: 'InviteDetail',
        path: '/invite-detail',
        props: true,
        component: () => import('@/views/invite-detail/index.vue'),
        meta: { title: '星探计划' },
      },
    ],
  },
  {
    name: 'ErrorPage',
    path: '/page-error',
    component: () => import('@/views/page-error/index.vue'),
  },
];

/**
 * asyncRoutes
 * 需要根据用户角色权限动态加载的路由
 */
export const asyncRoutes = [
  // 404 页面必须在最后
  { path: '*', redirect: '/404', hidden: true },
];

const { VUE_APP_PUBLIC_PATH = '' } = process.env;

const createRouter = () => new Router({
  mode: 'hash',
  base: `${VUE_APP_PUBLIC_PATH}/`,
  scrollBehavior: () => ({ x: 0, y: 0 }),
  routes: constantRoutes.concat(asyncRoutes as any),
});

const router = createRouter();

router.beforeEach((to, from, next) => {
  let title;
  if (isAn(store.state?.initialGlobalData?.device)) {
    title = to.meta.title || DEFAULT_TITLE;
  } else {
    // ios无法动态改变，防止页面打开其它链接之后回来title错乱，ios都设置成默认
    title = DEFAULT_TITLE;
  }
  // 修改文档名称
  document.title = title;
  next();
});

router.afterEach((to, from) => {
  store.commit('route/updateLastRouteName', from.name);
  store.commit('route/updateRefPg', encodeURIComponent(`pgid=${from.meta?.pgid || from.name || ''}`));
});

const originalRouteGo = router.go;
router.go = (n: number) => {
  if (n === -1) {
    console.log('go -1');
    store.commit('route/updateRouteTransitionType', RouteChangeTransitionType.Reverse);
  }
  originalRouteGo(n);
};

window.addEventListener('popstate', () => {
  console.log('popstate');
  store.commit('route/updateRouteTransitionType', RouteChangeTransitionType.Reverse);
}, true);

export const resetRouter = function () {
  const newRouter: any = createRouter();
  (router as any).matcher = newRouter.matcher;
};

export default router;
